import "./CashPayment.css";
import React, { useState, useRef, useEffect, useContext } from "react";
// import "../../styles/SchemeCashPayeipt.css";
// import "../../styles/SchemeRegistration.css";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import close from "../../../assets/images/findclose.png";
//import ComboBox from "shersoft-combov1";
import ComboBox from "../../../../src/components/ComboBoxes/ComboBox";
import axios from "axios";
import Print from "../../PrintModels/Print";
import io from "socket.io-client";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../../components/NavBars/ActionToolbar";
import GridDesign from "../../GridDesign/GridDesign";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";
import { createGridKeyDownHandler } from "../../../utils/gridKeyDownHelper";

import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function CashPaymentInner({
  onClose,
  Open,
  ledgerJustClosed,
  formId,
  formName,
  zIndex,
  voucherType,
}) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { agentCode } = useContext(AuthContext);
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);

  // ── FormDesign hook ──
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
    breakoutColumn,
    breakoutTarget,
    setRowBreakColumn,
    setRowBreakTarget,
    setBreakoutColumn,
    setBreakoutTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;
  const [frmId, setfrmid] = useState(() => formId ? parseInt(formId) : 0);
  const [fname, setfname] = useState("");
  ////////////////console.log("frmId",frmId);

  useEffect(() => {
    if (formId) {
      setfrmid(parseInt(formId));
    }
    setfname(formName);
  }, [formId, formName]);
  // //////////////////////console.log("frmId===", frmId);
  const { dbCode } = useDbContext();

  const vType = voucherType || formName || "CPAY";

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (parsed && Array.isArray(parsed)) {
            const sorted = [...parsed].sort((a, b) => a.orderNo - b.orderNo);
            setGridColumns(sorted);
            return;
          }
        } catch (e) {
          console.error("Error parsing cached grid columns:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
        );
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          const mapped = response.data.map((c) => ({
            sNo: c.SNo,
            columnName: c.ColumnName,
            width: c.ColWidth,
            orderNo: c.OrderNo,
            header: c.Header,
            show: c.Show === 1,
          }));
          const sorted = [...mapped].sort((a, b) => a.orderNo - b.orderNo);
          setGridColumns(sorted);
          localStorage.setItem(`grid_design_${vType}`, JSON.stringify(sorted));
        } else {
          setGridColumns(defaultCashPaymentGridColumns);
        }
      } catch (err) {
        console.error("Error loading grid design from db:", err);
        setGridColumns(defaultCashPaymentGridColumns);
      }
    };

    loadGridSettings();
  }, [dbCode, vType]);

  const permissions = useSelector(selectMenuPermissions);

  const ledstatus = () => {
    // //////////////////////console.log("ledstatus");
  };

  const [userType, setuserType] = useState("");

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
    }
  }, []);

  useEffect(() => {
    if (ledgerJustClosed) {
      ledstatus();
    }
  }, [ledgerJustClosed]);

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [showPrintModel, setShowPrintModel] = useState(false);
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);
  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const dropdownRef = useRef(null);

  const [printData, setPrintData] = useState(null);

  const handleClosePrint = () => {
    setShowPrintModel(false);
  };
  const [startDate, setStartDate] = useState(new Date());
  /////////////table///////////
  const tableContainerRef = useRef(null);
  const cashaccref = useRef(null);

  const defaultCashPaymentGridColumns = [
    {
      sNo: 1,
      columnName: "Account",
      width: 280,
      orderNo: 0,
      header: "Select A/c (Paid To)",
      show: true,
    },
    {
      sNo: 2,
      columnName: "Amount",
      width: 130,
      orderNo: 1,
      header: "Amount",
      show: true,
    },
    {
      sNo: 3,
      columnName: "Disc",
      width: 130,
      orderNo: 2,
      header: "Disc",
      show: true,
    },
    {
      sNo: 4,
      columnName: "Total",
      width: 150,
      orderNo: 3,
      header: "Total",
      show: true,
    },
    {
      sNo: 5,
      columnName: "Narration",
      width: 150,
      orderNo: 4,
      header: "Narration",
      show: true,
    },
  ];

  const [gridColumns, setGridColumns] = useState(defaultCashPaymentGridColumns);

  const entryNoInputRef = useRef(null);
  const CashAccinputRef = useRef(null);
  const salesmaninputRef = useRef(null);

  const rateInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);
  const GtotalAmntRef = useRef(null);

  const addRow = () => {
    // //////////////////////console.log("add row called");
    setTableData([...tableData, {}]);
  };

  const handleKeyDownTable = (event, rowIndex, columnIndex) => {
    const visibleCols = gridColumns.filter((c) => c.show);
    const col = visibleCols[columnIndex];
    if (col) {
      handleDynamicKeyDown(event, `grid_${rowIndex}_${col.columnName}`);
    }
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  // const handleScroll = () => {
  //   const tableContainer = tableContainerRef.current;
  //   if (
  //     tableContainer.scrollTop + tableContainer.clientHeight >=
  //     tableContainer.scrollHeight - 1
  //   ) {
  //     // User has scrolled to the bottom, add new rows
  //     addRow();
  //   }
  // };

  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();

  //////////current date///////////

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY bounds
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  ////////////////////////// form data states //////////

  const [tableData, setTableData] = useState([
    ...Array(14).fill({
      SINo: "",
      Account: "",
      Amount: "",
      Disc: "",
      Total: "",
      Narration: "",
    }),
  ]);
  ////////////////console.log("tableData", tableData);

  const [locationOptions, setLocationOptions] = useState([]);

  const storedLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
  const storedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");

  const getDefaultBranch = () => {
    if (activeLocation?.id) return [Number(activeLocation.id), activeLocation.name];
    if (storedLocId) return [Number(storedLocId), storedLocName || "SHOP"];
    return [0, "SHOP"];
  };

  const [cashPayInfoData, setcashPayInfoData] = useState({
    EntryNo: "",
    CashAcc: "",
    Salesman: "",
    date: initialDateVal,
    totalamt: "",
    totalDisc: "",
    totalamtdisc: "",
    Group: "",
    Location: getDefaultBranch(),
  });

  useEffect(() => {
    const fetchLocations = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`
        );
        const data = response.data || [];
        const filtered = data
          .filter((item) => String(item.Type || item.type || "").toLowerCase() === "location")
          .map((item) => [Number(item.Auto ?? item.auto ?? 0), item.Name || item.name]);
        setLocationOptions(filtered);

        if (filtered.length > 0) {
          const targetId = activeLocation?.id || storedLocId;
          const match = targetId ? filtered.find((l) => Number(l[0]) === Number(targetId)) : null;
          const chosen = match || filtered[0];
          setcashPayInfoData((prev) => {
            if (!prev.Location || !prev.Location[0] || prev.Location[0] === 0) {
              return { ...prev, Location: chosen };
            }
            return prev;
          });
        }
      } catch (error) {
        console.error("Error fetching location options:", error);
      }
    };
    fetchLocations();
  }, [apiBaseUrl, dbCode, activeLocation]);
  //////////////console.log("cashPayInfoData", cashPayInfoData);

  // const fetchcashAcc = async (data) => {
  //   try {
  //     const response = await axios.get(
  //       `${apiBaseUrl}/main/fetchcashacc/${parseInt(
  //         frmId ? frmId : agentCode
  //       )}/${dbCode}`
  //     );
  //     const caba = response.data[0];
  //     // //////////////////////console.log("agentcode,==", parseInt(agentCode));

  //     // //////////////////////console.log("caba===", caba.cashAcc);

  //     cashPayInfoData((prevState) => ({
  //       ...prevState,
  //       CashAcc: data.find((item) => item[0] === parseInt(caba.cashAcc)),
  //     }));
  //     // //////////////////////console.log(
  //     //   "acc=",
  //     //   data.find((item) => item[0] === parseInt(caba.cashAcc))
  //     // );
  //   } catch (error) {
  //     console.error("Error fetching Accno data:", error.message);
  //   }
  // };

  const [selectcashAcc, setselectcashAcc] = useState([]);
  // //////////////////////console.log("selectcashAcc", selectcashAcc);

  useEffect(() => {
    const selectcashAcc = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const caba = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = caba.map((item) => [
          item.ledcode,
          item.LedName,
        ]);
        setselectcashAcc(transformedData);

        // if (userType === "EMPLOYEE") {
        //   //////////////////////console.log("function called");

        //   fetchcashAcc(transformedData);
        // }

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching selectcashAcc Values:", error.message);
      }
    };
    selectcashAcc();
  }, [apiBaseUrl, userType]);

  const Selectcashacc = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
      );

      // Assuming response.data is an array with objects and each object has a LedName property
      const caba = response.data;

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = caba.map((item) => [item.ledcode, item.LedName]);
      setselectcashAcc(transformedData);
      // if (userType === "EMPLOYEE") {
      //   //////////////////////console.log("function called");

      //   fetchcashAcc(transformedData);
      // }

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching selectcashAcc Values:", error.message);
    }
  };

  const openPrintModal = () => {
    const slnoLimit = handleCheckSlno();
    if (selectedSlNo > slnoLimit || selectedSlNo <= 0) {
      alert("Enter SlNo Correctly");
      return;
    }

    setPrintData({
      tableData: tableData,
      cashPayInfoData: cashPayInfoData,
      index: selectedSlNo,
    });
    setShowPrintModel(true);
  };
  // //////////////////////console.log("table data ===== ", tableData);

  //  //////////////////////console.log("info data = ", cashPayInfoData);

  ///////////////////////////////////////////////
  // const[accountTransaction,setAccountTransaction]=useState({

  // atDate:"",
  // atLedcode:"",
  // atType:"",
  // atEntryNo:"",
  // atAmount:"",
  // atNarration:"",

  //})

  ///////////////////////////////////////////////

  const handleCellChange = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array
    newData[rowIndex] = { ...newData[rowIndex], [field]: event }; // Update the value of the specified field in the row
    setTableData(newData); // Update the tableData state with the modified data
  };

  const handleCellChangeinput = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array

    if (field === "printgm") {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.checked ? 1 : 0, // If checkbox is checked, set value to 1, otherwise 0
      };
    } else {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.value,
      }; // Update the value of the specified field in the row
    }
    newData[rowIndex] = { ...newData[rowIndex], SINo: rowIndex + 1 }; // Update the SINo for the row
    setTableData(newData); // Update the tableData state with the modified data
  };

  useEffect(() => {
    triggerInitialFocus();
  }, [triggerInitialFocus]);

  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === "Enter" || event.key === "Return") {
      nextInputRef.current.focus();
    }
  };
  const [RowIndex, setRowIndex] = useState(0);

  const backtrackfocus = () => {
    const rowIndex = sessionStorage.getItem("cashPayEntryRowIndex");
    const columnIndex = sessionStorage.getItem("cashPayEntryColumnIndex");

    const tableContainer = tableContainerRef.current;
    const rows = tableContainer.querySelectorAll(
      ".cashPayDataTableBodyStyletr",
    );

    if (rows[rowIndex]) {
      const dataRowDiv = rows[rowIndex]?.children[0];
      if (dataRowDiv) {
        const nextColumnIndex =
          Number(columnIndex) - 1 < dataRowDiv.children.length - 1
            ? Number(columnIndex)
            : 0;
        const nextInput = dataRowDiv.children[nextColumnIndex]?.querySelector("input");
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
    sessionStorage.removeItem("cashPayEntryRowIndex");
    sessionStorage.removeItem("cashPayEntryColumnIndex");
  };
  // //////////////////////console.log(RowIndex);



  /////////////////////////////////////////////

  useEffect(() => {
    const fetchSchEntryno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/voucher/pv_entryno/${formId}/${dbCode}/${fyid}`,
        );
        //  //////////////////////console.log("response =", response);
        const schemeRecentryNo = response.data;

        setcashPayInfoData((prevData) => ({
          ...prevData,
          EntryNo: schemeRecentryNo,
        }));
        // setSchEntryNo(schemeentryNo[0] );
      } catch (error) {
        console.error("Error fetching entry no:", error.message);
      }
    };

    fetchSchEntryno();
  }, [apiBaseUrl, fyid]);

  const fetchSchEntryno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/pv_entryno/${formId}/${dbCode}/${fyid}`,
      );
      // //////////////////////console.log("response =", response);
      const schemeRecentryNo = response.data;

      setcashPayInfoData((prevData) => ({
        ...prevData,
        EntryNo: schemeRecentryNo,
      }));
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };

  //////////agent name///////////////

  const [agentName, setagentName] = useState([]);
  // const [agentobj, setAgentObj] = useState([]);

  useEffect(() => {
    const fetchAgname = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/jvschsalesmanNames/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const AgName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    fetchAgname();
  }, [apiBaseUrl, dbCode]);

  // const fetchAgname = async (searchTerm = '') => {
  //   try {
  //     const response = await axios.get(`${apiBaseUrl}/main/jvschsalesmanNames?search=${encodeURIComponent(searchTerm)}`);
  //     const AgName = response.data;
  //     const transformedData = AgName.map((item) => [item.Auto, item.Name]);
  //     setagentName(transformedData);
  //   } catch (error) {
  //     console.error("Error fetching agent Values:", error.message);
  //   }
  // };
  // const handleAgentSearch = (searchTerm) => {
  //   fetchAgname(searchTerm);
  // };

  ////////////////////ledger/////////////////////

  const [LedgerName, setLedgerName] = useState([]);

  useEffect(() => {
    const fetchLgname = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/jvledgernames/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const LgName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = LgName.map((item) => [
          item.Ledcode,
          item.LedName,
        ]);
        setLedgerName(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
      backtrackfocus();
    };

    fetchLgname();

    // Connect to the WebSocket server
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("PaymentVoucherUpdated", () => {
      //   //////////////////////console.log('Data updated, fetching new data...');
      fetchLgname(); // Re-fetch the data when an update is detected
    });
    socket.on("LedgerUpdated", () => {
      fetchLgname();
    });
    socket.on("dataUpdated", () => {
      fetchLgname();
    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
      //   //////////////////////console.log("socketdisconneccted");
    };
  }, [apiBaseUrl, dbCode]);

  const handleCheckLedger = (e, rowIndex, columnIndex) => {
    // //////////////////////console.log('regcustom',AcNames);
    // //////////////////////console.log("index==",rowIndex,columnIndex);

    const targetValue = e.target.value;

    const isValuePresent = LedgerName.some((item) => item[1] === targetValue);

    if (!isValuePresent && e.target.value !== "") {
      if (!window.confirm("Ledger Does not Exists,Create New..?")) {
        return;
      }
      Open(e, rowIndex, columnIndex);
    } else {
      findLedBalance(rowIndex, 1);
    }
  };

  ////////////////total calculations/////////////////////////////

  useEffect(() => {
    let totalAmount = 0;
    let totalDisc = 0;
    let totalDiscAmt = 0;
    tableData.forEach((rowData) => {
      totalAmount += parseFloat(rowData.Amount || 0);
      totalDisc += parseFloat(rowData.Disc || 0);
      totalDiscAmt += parseFloat(rowData.Total || 0);
    });
    //////////////////console.log(totalAmount, totalDisc, totalDiscAmt);

    setcashPayInfoData((prevState) => ({
      ...prevState,
      totalamt: totalAmount.toFixed(3), // Update total amount
      totalDisc: totalDisc.toFixed(3), // Update total amount
      totalamtdisc: totalDiscAmt.toFixed(3), // Update total amount
    }));
  }, [tableData]);

  ////////////////////
  // ////////////////console.log(tableData);

  const amtPlusdisc = (rowIndex) => {
    let amt = parseFloat(tableData[rowIndex].Amount || 0);
    let disc = parseFloat(tableData[rowIndex].Disc || 0);
    let totalAmt = amt + disc;
    handleCellChange(totalAmt, rowIndex, "Total");
  };

  /////////////////////////////

  const [comboValue, setComboValue] = useState("");
  const handleClearCombo = () => {
    setComboValue("");
  };
  ///////////////////////////////////clear/////////////////////////////

  const handleClear = () => {
    fetchSchEntryno();

    setcashPayInfoData({
      CashAcc: "",
      Salesman: "",
      date: getCurrentDate(),
      totalamt: "",
      totalDisc: "",
      totalamtdisc: "",
      Group: "",
      Location: getDefaultBranch(),
    });

    setTableData([
      ...Array(14).fill({
        SINo: "",
        Account: "",
        Amount: "",
        Disc: "",
        Total: "",
        Narration: "",
      }),
    ]);

    entryNoInputRef.current.focus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setLedBalance("0.00");
    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };

  const handleClearfind = () => {
    setcashPayInfoData({
      EntryNo: "",
      CashAcc: "",
      Salesman: "",
      date: getCurrentDate(),
      totalamt: "",
      totalDisc: "",
      totalamtdisc: "",
      Group: "",
      Location: getDefaultBranch(),
    });

    setTableData([
      ...Array(14).fill({
        SINo: "",
        Account: "",
        Amount: "",
        Disc: "",
        Total: "",
        Narration: "",
      }),
    ]);

    entryNoInputRef.current.focus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setLedBalance("0.00");

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };
  ////////////////////////////////////////////////////////

  const handleSave = async () => {
    setSaveDisabled(true);

    try {
      if (cashPayInfoData.date && !isDateInFy(cashPayInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        return;
      }
      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.Account ||
            !row.Amount ||
            !row.Total ||
            !cashPayInfoData.EntryNo ||
            !cashPayInfoData.Salesman ||
            !cashPayInfoData.CashAcc)
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.Account &&
          row.Amount &&
          row.Total &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        alert("Enter Data  Correctly.");
        setSaveDisabled(false);

        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        Account: row.Account[0] || null,
        Amount: parseInt(row.Amount) || null,
        Disc: parseInt(row.Disc) || null,
        Total: parseInt(row.Total) || null,

        Narration: row.Narration || null,
      }));
      // //////////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(
        `${apiBaseUrl}/voucher/savePaymentVoucher/${parseInt(
          frmId,
        )}/${dbCode}/${fyid}`,
        {
          EntryNo: cashPayInfoData.EntryNo,
          CashAcc: cashPayInfoData.CashAcc[0],
          Salesman: cashPayInfoData.Salesman[0],
          date: cashPayInfoData.date,
          totalamt: cashPayInfoData.totalamt,
          totalDisc: cashPayInfoData.totalDisc,
          totalamtdisc: cashPayInfoData.totalamtdisc,
          Location: Number(
            cashPayInfoData.Location?.[0] ||
            activeLocation?.id ||
            sessionStorage.getItem("loginLocationId") ||
            0
          ),

          type: transformedTableData, // Pass the entire tableData array
        },
      );

      if (response.data.success) {
        handleClear();
        //  Swal.fire("Success", "Data saved successfully!", "success");

        alert("Entry Saved");

        // Optionally, you can perform additional actions after successful save
      } else {
        //Swal.fire("Error", "Failed to save data!", "error");
        // alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      //  Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
      setSaveDisabled(false);
    }
    // handleClear();
  };

  const handleEdit = async () => {
    try {
      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.Account ||
            !row.Amount ||
            !row.Total ||
            !cashPayInfoData.EntryNo ||
            !cashPayInfoData.Salesman ||
            !cashPayInfoData.CashAcc)
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly.");
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.Account &&
          row.Amount &&
          row.Total &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        alert("Enter Data  Correctly.");
        setSaveDisabled(false);

        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        Account: row.Account[0] || null,
        Amount: parseInt(row.Amount) || null,
        Disc: parseInt(row.Disc) || null,
        Total: parseInt(row.Total) || null,

        Narration: row.Narration || null,
      }));
      // //////////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.put(
        `${apiBaseUrl}/voucher/updatePaymentVoucher/${parseInt(
          frmId,
        )}/${dbCode}/${fyid}`,
        {
          EntryNo: cashPayInfoData.EntryNo,
          CashAcc: cashPayInfoData.CashAcc[0],
          Salesman: cashPayInfoData.Salesman[0],
          date: cashPayInfoData.date,
          totalamt: cashPayInfoData.totalamt,
          totalDisc: cashPayInfoData.totalDisc,
          totalamtdisc: cashPayInfoData.totalamtdisc,
          Location: Number(
            cashPayInfoData.Location?.[0] ||
            activeLocation?.id ||
            sessionStorage.getItem("loginLocationId") ||
            0
          ),

          type: transformedTableData, // Pass the entire tableData array
        },
      );

      if (response.data.success) {
        handleClear();
        //  Swal.fire("Success", "Data saved successfully!", "success");

        alert("Entry Updated");

        // Optionally, you can perform additional actions after successful save
      } else {
        //Swal.fire("Error", "Failed to save data!", "error");
        // alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      //  Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
    }
    // handleClear();
  };

  ////////////////////////console.log("datra",tableData[0].accountNumber);

  const [showFindDialog, setShowFindDialog] = useState(false); // State for controlling the visibility of the find dialog
  const [findEntryNo, setFindEntryNo] = useState(""); // State to store the entry number entered in the find dialog
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [selectedSlNo, setSelectedSlno] = useState("");

  // //////////////////////console.log(findEntryNo);
  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const openPrintDialog = () => {
    setShowPrintDialog(true);
  };

  const closePrintDialog = () => {
    setShowPrintDialog(false);
  };

  const [firstEno, setFirstEno] = useState("");
  const [lastEno, setLastEno] = useState("");
  ////////////////////////console.log(firstEno,lastEno);

  const fetchfirstandlast = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/financialyear/cvtopandlast/${dbCode}/${fyid}`,
      );
      if (response.status === 200) {
        setFirstEno(response.data[0].firstentryno);
        setLastEno(response.data[0].lastentryno);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // //////////////////////console.log('accNo==',accNo);
  // //////////////////////console.log('accccc=',accNo.find((item) => item[0] === 10));

  const handleFindbyentrynumber = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/findpv/${dbCode}/${fyid}/${parseInt(
          frmId,
        )}/${findEntryNo}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        const infoData = response.data[0][0];
        const partiData = response.data[1];
        //////////////console.log("partiData", partiData);
        const updatedTableData = partiData.map((row, index) => ({
          Account: [row.Ledcode, row.LedName],
          Amount: row.Amount,
          Disc: row.Discount,
          Total: row.Total,
          Narration: "",
        }));

        setTableData((prevTableData) => [
          ...updatedTableData,
          ...prevTableData,
        ]);

        setcashPayInfoData({
          ...cashPayInfoData,
          EntryNo: infoData.EntryNo,
          CashAcc: [infoData.Ledcode, infoData.LedName],
          Salesman: agentName.find((item) => {
            const rawVal = (infoData.SalesMan !== undefined && infoData.SalesMan !== null && (Array.isArray(infoData.SalesMan) ? infoData.SalesMan[0] : infoData.SalesMan) != 0) 
              ? infoData.SalesMan 
              : infoData.Salesman;
            const dbVal = Array.isArray(rawVal) ? rawVal[0] : (rawVal && typeof rawVal === 'object' && Array.isArray(rawVal.data) ? rawVal.data[0] : rawVal);
            return item[0] == dbVal;
          }),
          date: formatDate(infoData.DDATE),
          totalamtdisc: infoData.AMOUNT,
          Location: locationOptions.find((item) => item[0] === infoData.Location) || [infoData.Location, "SHOP"],
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  // //////////////////////console.log('formatted date',formatDate);

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/voucher/deletepv/${dbCode}/${fyid}/${parseInt(frmId)}/${
          cashPayInfoData.EntryNo
        }?location=${cashPayInfoData.Location ? cashPayInfoData.Location[0] : 0}`,
      );
      if (response.status === 200) {
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Scheme deleted",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        alert("Entry Deleted Successfully!");
        // window.location.reload();
        handleClear();
      } else {
        console.error("Error deleting data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleFindprev = async () => {
    let { EntryNo } = cashPayInfoData;
    const newEntryNo = parseInt(EntryNo) - 1;

    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/findpv/${dbCode}/${fyid}/${parseInt(
          frmId,
        )}/${newEntryNo}`,
      );

      if (response.status === 200) {
        const infoData = response.data[0][0];
        const partiData = response.data[1];
       // console.log("infoData",  infoData[0][0].SalesMan[0]);
        ////////////console.log("response====", response);

        if (infoData.EntryNo === "") {
        }
        handleClearfind();

        const updatedTableData = partiData.map((row, index) => ({
          Account: [row.Ledcode, row.LedName],
          Amount: row.Amount,
          Disc: row.Discount,
          Total: row.Total,
          Narration: "",
        }));

        setTableData((prevTableData) => [
          ...updatedTableData,
          ...prevTableData,
        ]);

        setcashPayInfoData({
          ...cashPayInfoData,
          EntryNo: infoData.EntryNo,
          CashAcc: [infoData.Ledcode, infoData.LedName],
          Salesman: agentName.find((item) => {
            const rawVal = (infoData.SalesMan !== undefined && infoData.SalesMan !== null && (Array.isArray(infoData.SalesMan) ? infoData.SalesMan[0] : infoData.SalesMan) != 0) 
              ? infoData.SalesMan 
              : infoData.Salesman;
            const dbVal = Array.isArray(rawVal) ? rawVal[0] : (rawVal && typeof rawVal === 'object' && Array.isArray(rawVal.data) ? rawVal.data[0] : rawVal);
            return item[0] == dbVal;
          }),
          date: formatDate(infoData.DDATE),
          totalamtdisc: infoData.AMOUNT,
          Location: locationOptions.find((item) => item[0] === infoData.Location) || [infoData.Location, "SHOP"],
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindnext = async () => {
    let { EntryNo } = cashPayInfoData;
    const newEntryNo = parseInt(EntryNo) + 1;

    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/findpv/${dbCode}/${fyid}/${parseInt(
          frmId,
        )}/${newEntryNo}`,
      );

      if (response.status === 200) {
        const infoData = response.data[0][0];
        const partiData = response.data[1];
        //////////////console.log("partiData", partiData);

        if (infoData.EntryNo === "") {
          return;
        }
        handleClearfind();

        const updatedTableData = partiData.map((row, index) => ({
          Account: [row.Ledcode, row.LedName],
          Amount: row.Amount,
          Disc: row.Discount,
          Total: row.Total,
          Narration: "",
        }));

        setTableData((prevTableData) => [
          ...updatedTableData,
          ...prevTableData,
        ]);

        setcashPayInfoData({
          ...cashPayInfoData,
          EntryNo: infoData.EntryNo,
          CashAcc: [infoData.Ledcode, infoData.LedName],
          Salesman: agentName.find((item) => {
            const rawVal = (infoData.SalesMan !== undefined && infoData.SalesMan !== null && (Array.isArray(infoData.SalesMan) ? infoData.SalesMan[0] : infoData.SalesMan) != 0) 
              ? infoData.SalesMan 
              : infoData.Salesman;
            const dbVal = Array.isArray(rawVal) ? rawVal[0] : (rawVal && typeof rawVal === 'object' && Array.isArray(rawVal.data) ? rawVal.data[0] : rawVal);
            return item[0] == dbVal;
          }),
          date: formatDate(infoData.DDATE),
          totalamtdisc: infoData.AMOUNT,
          Location: locationOptions.find((item) => item[0] === infoData.Location) || [infoData.Location, "SHOP"],
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindfirst = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/findfirstpv/${dbCode}/${fyid}/${parseInt(frmId)}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        const infoData = response.data[0][0];
        const partiData = response.data[1];
        //////////////console.log("partiData", partiData);
        const updatedTableData = partiData.map((row, index) => ({
          Account: [row.Ledcode, row.LedName],
          Amount: row.Amount,
          Disc: row.Discount,
          Total: row.Total,
          Narration: "",
        }));

        setTableData((prevTableData) => [
          ...updatedTableData,
          ...prevTableData,
        ]);

        setcashPayInfoData({
          ...cashPayInfoData,
          EntryNo: infoData.EntryNo,
          CashAcc: [infoData.Ledcode, infoData.LedName],
          Salesman: agentName.find((item) => {
            const rawVal = (infoData.SalesMan !== undefined && infoData.SalesMan !== null && (Array.isArray(infoData.SalesMan) ? infoData.SalesMan[0] : infoData.SalesMan) != 0) 
              ? infoData.SalesMan 
              : infoData.Salesman;
            const dbVal = Array.isArray(rawVal) ? rawVal[0] : (rawVal && typeof rawVal === 'object' && Array.isArray(rawVal.data) ? rawVal.data[0] : rawVal);
            return item[0] == dbVal;
          }),
          date: formatDate(infoData.DDATE),
          totalamtdisc: infoData.AMOUNT,
          Location: locationOptions.find((item) => item[0] === infoData.Location) || [infoData.Location, "SHOP"],
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleFindlast = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/voucher/findlastpv/${dbCode}/${fyid}/${parseInt(frmId)}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        const infoData = response.data[0][0];
        const partiData = response.data[1];
        //////////////console.log("partiData", partiData);
        const updatedTableData = partiData.map((row, index) => ({
          Account: [row.Ledcode, row.LedName],
          Amount: row.Amount,
          Disc: row.Discount,
          Total: row.Total,
          Narration: "",
        }));

        setTableData((prevTableData) => [
          ...updatedTableData,
          ...prevTableData,
        ]);

        setcashPayInfoData({
          ...cashPayInfoData,
          EntryNo: infoData.EntryNo,
          CashAcc: [infoData.Ledcode, infoData.LedName],
          Salesman: agentName.find((item) => {
            const rawVal = (infoData.SalesMan !== undefined && infoData.SalesMan !== null && (Array.isArray(infoData.SalesMan) ? infoData.SalesMan[0] : infoData.SalesMan) != 0) 
              ? infoData.SalesMan 
              : infoData.Salesman;
            const dbVal = Array.isArray(rawVal) ? rawVal[0] : (rawVal && typeof rawVal === 'object' && Array.isArray(rawVal.data) ? rawVal.data[0] : rawVal);
            return item[0] == dbVal;
          }),
          date: formatDate(infoData.DDATE),
          totalamtdisc: infoData.AMOUNT,
          Location: locationOptions.find((item) => item[0] === infoData.Location) || [infoData.Location, "SHOP"],
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const [ledBalance, setLedBalance] = useState("0.00");

  const findLedBalance = async (rowIndex, ledcode) => {
    // ////////////console.log("tableData[rowIndex].Account[0]",tableData[rowIndex].Account[0],rowIndex);
    // ////////////console.log(tableData);

    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/ledgerbalance/${dbCode}/${parseInt(
          ledcode ? ledcode : tableData[rowIndex].Account[0],
        )}`,
      );

      if (response.status === 200) {
        const responseData = response.data[0].balance;
        // ////////////console.log("responseData",responseData);
        setLedBalance(responseData);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleCheckSlno = () => {
    const filteredTableData = tableData.filter((row) => {
      // Check if any of the fields in the row is not empty
      return Object.values(row).some((value) => value !== "");
    });
    const filteredTableDataLength = filteredTableData.length;
    return filteredTableDataLength;
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    handleClear();
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  return (
    <div className="cashPayRoot" style={{ zIndex }}>
      <WindowHeader
        title={fname || "Cash Payment"}
        logo={headeLogo}
        onClose={() => {
          onClose();
          setfrmid("");
          setfname("");
        }}
        style={{ height: "30px" }}
        className="bg-[#0f56d3] text-white"
        titleClassName="text-xs"
        closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2 flex items-center justify-center"
      />

        {/* ActionToolbar */}
        <ActionToolbar
          width="100%"
          height="auto"
          size="small"
          iconSize={14}
          navBgColor="#0f56d3"
          navIconColor="#ffffff"
          buttonGap="5px"
          saveBtnId="SaveBtn"
          printBtnId="PrintBtn"
          clearBtnId="ClearBtn"
          findBtnId="FindBtn"
          editBtnId="EditBtn"
          deleteBtnId="DeleteBtn"
          exitBtnId="ExitBtn"
          saveDisabled={saveDisabled}
          editDisabled={editDisabled}
          deleteDisabled={deleteDisabled}
          dataFound={!editDisabled}
          onSave={handleSave}
          onPrint={openPrintDialog}
          onClear={handleClear}
          onFind={openFindDialog}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onExit={onClose}
          onFirst={handleFindfirst}
          onPrevious={handleFindprev}
          onNext={handleFindnext}
          onLast={handleFindlast}
          permissions={permissions["cashReceipt"]}
          showSave={isFieldVisible("SaveBtn")}
          showPrint={isFieldVisible("PrintBtn")}
          showClear={isFieldVisible("ClearBtn")}
          showFind={isFieldVisible("FindBtn")}
          showEdit={isFieldVisible("EditBtn")}
          showDelete={isFieldVisible("DeleteBtn")}
          showExit={isFieldVisible("ExitBtn")}
          showSettingsBar={true}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          settingsOptions={[
            {
              label: "Design Columns",
              onClick: () => setShowGridDesignModal(true),
            },
            {
              label: "Design Form",
              onClick: () => setShowFormDesignModal(true),
            },
          ]}
          onRefsUpdate={(refs) => {
            if (refs.saveButtonRef && refs.saveButtonRef.current) {
              saveButtonRef.current = refs.saveButtonRef.current;
              registerRef("SaveBtn")(refs.saveButtonRef.current);
            }
            if (refs.editButtonRef && refs.editButtonRef.current) {
              editButtonRef.current = refs.editButtonRef.current;
              registerRef("EditBtn")(refs.editButtonRef.current);
            }
          }}
        />

      <div className="cashPayBody">
        <div className="cashPayBodyData">
          <div className="cashPayTopdata">
            <div className="cashPayTopdatasections cashPaysec1" style={getContainerStyle("EntryNo")}>
              {isFieldVisible("EntryNo") && (
                <div className="cashPayTopdatasectionsrows cashPayentryno">
                  <label style={getLabelStyle("EntryNo")}>Entry No</label>
                  <input
                    id="EntryNo"
                    ref={(el) => {
                      entryNoInputRef.current = el;
                      registerRef("EntryNo")(el);
                    }}
                    readOnly
                    style={getInputStyle("EntryNo", { textAlign: "center" })}
                    value={cashPayInfoData.EntryNo}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "EntryNo")}
                    onChange={(e) =>
                      setcashPayInfoData({
                        ...cashPayInfoData,
                        EntryNo: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <div className="cashPayTopdatasectionsrows"></div>
            </div>
            <div className="cashPayTopdatasections cashPaysec2">
              {isFieldVisible("CashAcc") && (
                <div className="cashPayTopdatasectionsrows sec2row " style={getContainerStyle("CashAcc")}>
                  <label className="cashPaysec2label" style={getLabelStyle("CashAcc")}>Select Cash A/c</label>
                  <ComboBox
                    id="CashAcc"
                    findedValue={
                      Array.isArray(cashPayInfoData.CashAcc)
                        ? cashPayInfoData.CashAcc[1]
                        : cashPayInfoData.CashAcc
                    }
                    comboRef={(el) => {
                      CashAccinputRef.current = el;
                      registerRef("CashAcc")(el);
                    }}
                    options={selectcashAcc}
                    className="cashPaycashaccCombo"
                    inputClassName="cashPaycashaccComboinput"
                    inputStyle={getInputStyle("CashAcc")}
                    onKeyDown={(e) => {
                      handleDynamicKeyDown(e, "CashAcc");
                    }}
                    onInputChange={(e) =>
                      setcashPayInfoData({ ...cashPayInfoData, CashAcc: e })
                    }
                  />
                  <label htmlFor="" className="cashPayamntlabel" style={getLabelStyle("CashAcc")}>
                    Amount
                  </label>
                  <input
                    value={cashPayInfoData.totalamtdisc}
                    ref={GtotalAmntRef}
                    className="cashPayamnt"
                    style={getInputStyle("CashAcc")}
                    onKeyDown={(e) => {
                      handleKeyDown(e, dateInputRef);
                    }}
                    onChange={(e) =>
                      setcashPayInfoData({
                        ...cashPayInfoData,
                        totalamtdisc: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              {isFieldVisible("Salesman") && (
                <div className="cashPayTopdatasectionsrows sec2row " style={getContainerStyle("Salesman")}>
                  <label className="cashPaysec2label" style={getLabelStyle("Salesman")}>Select Salesman</label>
                  <ComboBox
                    id="Salesman"
                    findedValue={
                      Array.isArray(cashPayInfoData.Salesman)
                        ? cashPayInfoData.Salesman[1]
                        : cashPayInfoData.Salesman
                    }
                    comboRef={(el) => {
                      salesmaninputRef.current = el;
                      registerRef("Salesman")(el);
                    }}
                    options={agentName}
                    className="cashPaycashaccCombo"
                    inputClassName="cashPaycashaccComboinput"
                    inputStyle={getInputStyle("Salesman")}
                    onKeyDown={(e) => {
                      handleDynamicKeyDown(e, "Salesman");
                    }}
                    onInputChange={(e) => {
                      setcashPayInfoData({ ...cashPayInfoData, Salesman: e });
                    }}
                  />
                </div>
              )}
            </div>
            <div className="cashPayTopdatasections  cashPaySec3" style={getContainerStyle("Date")}>
              {isFieldVisible("Date") && (
                <div className="cashPayTopdatasectionsrows cashPaysec3row">
                  <label style={getLabelStyle("Date")}>Date</label>
                  <input
                    id="Date"
                    value={cashPayInfoData.date}
                    type="date"
                    min={minDate}
                    max={maxDate}
                    ref={(el) => {
                      dateInputRef.current = el;
                      registerRef("Date")(el);
                    }}
                    style={getInputStyle("Date")}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "Date")}
                    onChange={(e) => {
                      setcashPayInfoData({
                        ...cashPayInfoData,
                        date: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      if (val && !isDateInFy(val)) {
                        alert("Date incompatible with financial year");
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/*---------------- receipt data table.----------------------- */}

          <div
            className="w-full h-[65%] flex flex-col shrink-0 text-black text-[10px] font-semibold overflow-y-auto overflow-x-auto"
            ref={tableContainerRef}
          >
            {/* ── Header ── */}
            <div className="w-max min-w-full flex sticky z-30 top-0">
              <div className="w-max min-w-full h-[1.5rem] bg-[#026CC3] flex">
                <div
                  style={{ width: 50, flexShrink: 0 }}
                  className="h-full cashPayTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                >
                  SI No
                </div>
                {gridColumns.map((col) => {
                  if (!col.show) return null;
                  return (
                    <div
                      key={col.columnName}
                      style={{ width: `${col.width}px`, flexShrink: 0 }}
                      className="h-full cashPayTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                    >
                      {col.header}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── Body ── */}
            <div className="w-max min-w-full h-max flex flex-col">
              {tableData.map((rowData, rowIndex) => {
                const handleGridKeyDown = createGridKeyDownHandler({
                  rowIndex, breakoutColumn, rowBreakColumn, rowBreakTarget,
                  formFields, addRow, focusField, handleDynamicKeyDown,
                });

                return (
                  <div
                    key={rowIndex}
                    className="cashPayDataTableBodyStyletr w-max min-w-full h-[3rem] bg-white flex flex-col"
                  >
                    {/* ── Top half: input fields ── */}
                    <div className="w-max min-w-full h-1/2 bg-white flex">
                      <div
                        className="h-full cashPayTableColBorder flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center text-black"
                        style={{ width: 50, flexShrink: 0 }}
                      >
                        {rowIndex + 1}
                      </div>

                      {gridColumns
                        .filter((c) => c.show)
                        .map((col, visibleIndex) => {
                          const colStyle = { width: `${col.width}px`, flexShrink: 0 };
                          const columnName = col.columnName;
                          const cellClass = "h-full cashPayTableColBorder flex items-center font-inter text-xs";

                          const renderCell = {
                            Account: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <ComboBox
                                  id={`grid_${rowIndex}_Account`}
                                  findedValue={
                                    Array.isArray(tableData[rowIndex]?.Account)
                                      ? (tableData[rowIndex]?.Account?.[1] ?? "")
                                      : tableData[rowIndex]?.Account
                                  }
                                  options={LedgerName}
                                  className="w-full h-full border-none"
                                  inputClassName="dataBox"
                                  comboRef={registerRef(`grid_${rowIndex}_Account`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "Account")}
                                  onInputChange={(e) => {
                                    handleCellChange(e, rowIndex, "Account");
                                    findLedBalance(rowIndex, Array.isArray(e) ? e[0] : "");
                                  }}
                                  onBlur={(e) => handleCheckLedger(e, rowIndex, 1)}
                                />
                              </div>
                            ),
                            Amount: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_Amount`}
                                  ref={registerRef(`grid_${rowIndex}_Amount`)}
                                  value={tableData[rowIndex]?.Amount || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right text-black text-xs"
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "Amount")}
                                  onKeyDown={(e) => handleGridKeyDown(e, "Amount")}
                                  type="number"
                                  onBlur={() => amtPlusdisc(rowIndex)}
                                />
                              </div>
                            ),
                            Disc: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_Disc`}
                                  ref={registerRef(`grid_${rowIndex}_Disc`)}
                                  value={tableData[rowIndex]?.Disc || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right text-black text-xs"
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "Disc")}
                                  onKeyDown={(e) => handleGridKeyDown(e, "Disc")}
                                  type="number"
                                  onBlur={() => amtPlusdisc(rowIndex)}
                                />
                              </div>
                            ),
                            Total: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_Total`}
                                  ref={registerRef(`grid_${rowIndex}_Total`)}
                                  value={tableData[rowIndex]?.Total || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right text-black text-xs"
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "Total")}
                                  onKeyDown={(e) => handleGridKeyDown(e, "Total")}
                                  type="number"
                                />
                              </div>
                            ),
                            Narration: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_Narration`}
                                  ref={registerRef(`grid_${rowIndex}_Narration`)}
                                  value={tableData[rowIndex]?.Narration || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-black text-xs"
                                  onKeyDown={(e) => handleGridKeyDown(e, "Narration")}
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "Narration")}
                                />
                              </div>
                            ),
                          };

                          const renderer = renderCell[columnName];
                          if (renderer) return renderer();
                          return <div key={columnName} style={colStyle} className="h-full cashPayTableColBorder" />;
                        })}
                    </div>

                  {/* ── Bottom half: secondary row (EBEBEB) ── */}
                  <div className="w-max min-w-full h-1/2 bg-[#EBEBEB] flex">
                    <div style={{ width: 50, flexShrink: 0 }} className="h-full" />
                    {gridColumns
                      .filter((c) => c.show)
                      .map((col) => (
                        <div
                          key={col.columnName}
                          style={{ width: `${col.width}px`, flexShrink: 0 }}
                          className="h-full"
                        />
                      ))}
                  </div>
                </div>
              );
            })}
            </div>

            {/* ── Footer ── */}
            <div className="w-max min-w-full py-1 box-border h-[26px] bg-[#026cc3] flex text-[10px] font-semibold leading-normal text-white sticky bottom-0 z-30">
              <div
                style={{ width: 50, flexShrink: 0 }}
                className="h-full flex items-center justify-center"
              />
              {gridColumns.filter((c) => c.show).map((col) => {
                const colStyle = { width: `${col.width}px`, flexShrink: 0 };
                const totalStyle = { textAlign: "right", width: "100%", height: "22px", border: "none", background: "white", paddingRight: "4px", boxSizing: "border-box", color: "#000", fontSize: "10px" };

                const renderFooterCell = {
                  Account: () => <div key={col.columnName} style={colStyle} className="h-full" />,
                  Amount: () => (
                    <div key={col.columnName} style={colStyle} className="h-full flex items-center justify-end px-[2px]">
                      <input value={cashPayInfoData.totalamt} style={totalStyle} readOnly />
                    </div>
                  ),
                  Disc: () => (
                    <div key={col.columnName} style={colStyle} className="h-full flex items-center justify-end px-[2px]">
                      <input value={cashPayInfoData.totalDisc} style={totalStyle} readOnly />
                    </div>
                  ),
                  Total: () => (
                    <div key={col.columnName} style={colStyle} className="h-full flex items-center justify-end px-[2px]">
                      <input value={cashPayInfoData.totalamtdisc} style={totalStyle} readOnly />
                    </div>
                  ),
                  Narration: () => (
                    <div key={col.columnName} style={colStyle} className="h-full flex items-center justify-center gap-2">
                      <label htmlFor="printob" className="font-Inter cursor-pointer text-[11px] text-white">Print Ob</label>
                      <input type="checkbox" id="printob" className="cursor-pointer" />
                    </div>
                  ),
                };

                const renderer = renderFooterCell[col.columnName];
                if (renderer) return renderer();
                return <div key={col.columnName} style={colStyle} className="h-full" />;
              })}
            </div>
          </div>

          <div className="cashPayCurrentBalance">
            {`Current Balance of Cash :${ledBalance}`}
          </div>
        </div>
      </div>

      {showFindDialog && (
        <div className="find-dialog">
          <input
            type="text"
            value={findEntryNo}
            onChange={(e) => setFindEntryNo(e.target.value)}
            placeholder="Enter Entry No"
          />
          <button onClick={handleFindbyentrynumber}>Find</button>
          {/* <button
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
          >
            Cancel
          </button> */}
          <div
            className="findCloseDiv"
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}

      {showPrintDialog && (
        <div className="find-dialog">
          <input
            type="text"
            // value={findEntryNo}
            onChange={(e) => setSelectedSlno(e.target.value)}
            placeholder="Enter Sl No"
          />
          <button onClick={openPrintModal}>Print</button>
          <div
            className="findCloseDiv"
            onClick={() => {
              closePrintDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}
      {showPrintModel && (
        <Print
          printData={printData}
          onClose={handleClosePrint}
          // totalwt={accumulatedWt}
        />
      )}
      {showGridDesignModal && (
        <GridDesign
          onClose={() => setShowGridDesignModal(false)}
          onSave={(columns) => {
            setGridColumns(columns);
            localStorage.setItem(`grid_design_${vType}`, JSON.stringify(columns));
            setShowGridDesignModal(false);
          }}
          formName={vType}
          initialColumns={defaultCashPaymentGridColumns}
          zIndex={zIndex}
        />
      )}
      {showFormDesignModal && (
        <FormDesign
          onClose={() => setShowFormDesignModal(false)}
          formName={vType}
          initialFields={defaultCashPaymentFormFields}
          zIndex={zIndex}
          highlightFieldId={activeFieldId}
          onSave={(updatedFields) => {
            setFormFields(updatedFields);
            // Sync row-break and breakout config values into context immediately
            const rowBreakColField = updatedFields.find(
              (f) => f.fieldId === "__GridRowBreakColumn",
            );
            const rowBreakTgtField = updatedFields.find(
              (f) => f.fieldId === "__GridRowBreakTarget",
            );
            const breakoutColField = updatedFields.find(
              (f) => f.fieldId === "__GridBreakoutColumn",
            );
            const breakoutTgtField = updatedFields.find(
              (f) => f.fieldId === "__GridBreakoutTarget",
            );
            if (rowBreakColField?.defaultValue)
              setRowBreakColumn(rowBreakColField.defaultValue);
            if (rowBreakTgtField?.defaultValue)
              setRowBreakTarget(rowBreakTgtField.defaultValue);
            if (breakoutColField?.defaultValue)
              setBreakoutColumn(breakoutColField.defaultValue);
            if (breakoutTgtField?.defaultValue)
              setBreakoutTarget(breakoutTgtField.defaultValue);
          }}
        />
      )}
    </div>
    // </div>
  );
}

const defaultCashPaymentFormFields = [
  // ── Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 0,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashAcc",
    fieldName: "Select Cash A/c",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Salesman",
    fieldName: "Select Salesman",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Cash Payment Grid",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_Account",
    fieldName: "Grid - Select A/c",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_Amount",
    fieldName: "Grid - Amount",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Disc",
    fieldName: "Grid - Disc",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Total",
    fieldName: "Grid - Total",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Narration",
    fieldName: "Grid - Narration",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 14,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 15,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 16,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "Account",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "SaveBtn",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "Narration",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "Account",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

function CashPayment(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const formName = props.voucherType || props.formName || "CPAY";
  return (
    <FormDesignProvider
      formName={formName}
      defaultFields={defaultCashPaymentFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <CashPaymentInner {...props} />
    </FormDesignProvider>
  );
}

export default CashPayment;
